var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPadlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14",
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#f7d881",
    height: 34,
    rx: 4,
    width: 38,
    x: 4,
    y: 28
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 39-3.31-.74a13.56 13.56 0 0 1 -8.69-6.26 13.56 13.56 0 0 1 -8.69 6.26l-3.31.74a28 28 0 0 0 11.2 22.4l.8.6.8-.6a28 28 0 0 0 11.2-22.4z",
    fill: "#78b75b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.86 57.35c8-2.16 14.14-9.46 15.74-18.66l-1.91-.43a13.56 13.56 0 0 1 -8.69-6.26 13.56 13.56 0 0 1 -8.69 6.26l-3.31.74a28 28 0 0 0 6.86 18.35z",
    fill: "#96cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 28h5v-10a10 10 0 0 1 20 0v10h5a4.09 4.09 0 0 1 1 .14v-10.14a16 16 0 0 0 -32 0v10.14a4.09 4.09 0 0 1 1-.14z",
    fill: "#c1c8d1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 36h12v18h-12z",
    fill: "#f5b95b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 46.55v-8.55a2 2 0 0 0 -2-2 2 2 0 0 0 -2 2v8.55a4 4 0 1 0 4 0z",
    fill: "#c1c8d1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 47,
    fill: "#ebf7fe",
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26 46v-8a3 3 0 0 0 -6 0v8a5 5 0 0 0 1.81 8.84 5.37 5.37 0 0 0 1.19.16 5 5 0 0 0 3-9zm-1.14 6.33a3 3 0 1 1 -3.36-4.93 1 1 0 0 0 .5-.87v-8.53a1 1 0 0 1 2 0v8.55a1 1 0 0 0 .5.87 3 3 0 0 1 .36 4.93z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.22 38-3.31-.73a12.63 12.63 0 0 1 -8-5.8 1 1 0 0 0 -1.72 0 12.55 12.55 0 0 1 -5.19 4.76v-4.23a5 5 0 0 0 -3-4.58v-9.42a17 17 0 0 0 -34 0v9.42a5 5 0 0 0 -3 4.58v3h-1a1 1 0 0 0 -1 1v18a1 1 0 0 0 1 1h1v3a5 5 0 0 0 5 5h30a5 5 0 0 0 5-5v-.13a29.08 29.08 0 0 0 4.6 4.33l.8.6a1 1 0 0 0 1.2 0l.8-.6a29.15 29.15 0 0 0 11.6-23.2 1 1 0 0 0 -.78-1zm-53.22-20a15 15 0 0 1 30 0v9h-4v-9a11 11 0 0 0 -22 0v9h-4zm24 9h-18v-9a9 9 0 0 1 18 0zm-19 10v4h-10v-4zm-10 16v-4h10v4zm10-6h-10v-4h10zm28 11a3 3 0 0 1 -3 3h-30a3 3 0 0 1 -3-3v-3h9a1 1 0 0 0 1-1v-18a1 1 0 0 0 -1-1h-9v-3a3 3 0 0 1 3-3h30a3 3 0 0 1 3 3v5c-.3.09-.6.18-.91.25l-3.31.75a1 1 0 0 0 -.78 1 29.14 29.14 0 0 0 5 16.24zm8.2 2.6-.2.15-.2-.15a27.15 27.15 0 0 1 -10.8-20.8l2.51-.56a14.63 14.63 0 0 0 8.49-5.45 14.63 14.63 0 0 0 8.48 5.45l2.52.56a27.15 27.15 0 0 1 -10.8 20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.89 40.45-1.78-.9-.68 1.35a7.09 7.09 0 1 0 1.57 1.26zm-.89 6.55a5.05 5.05 0 1 1 -2.47-4.29l-2.7 5.4-2-2.71-1.6 1.2 3 4a1 1 0 0 0 .8.4h.09a1 1 0 0 0 .8-.55l3.17-6.34a4.92 4.92 0 0 1 .91 2.89z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.8d2c33d2e558cdfc835d35b8ace79550.svg";
export { ForwardRef as ReactComponent };